const locale = "en-US";
const translations = {
	timeFormat: "h:mm a",
	dateFormat: "MM/DD/YYYY",
	dateTimeFormat: "MM/DD/YYYY h:mm a",
	serviceReports: {
		headline: "Service Reports",
		sublineMachine: "View and download service reports for your machine.",
		technicianName: "Technician name",
		machineNameAndNumber: "Machine & machine number",
		startDate: "from",
		endDate: "to",
		creationDate: "Creation Date",
		openReport: "Open Service Report",
		filter: "Filter",
		missionNumber: "Mission Number",
		assignmentType: "Service report type",
		assignmentTypes: {
			IA: "De-Installation / Relocation",
			AC: "Application consulting",
			IV: "Installation preparation",
			BA: "Appraisal",
			UV: "Safety inspection",
			IG: "Installation of pre-owned machine",
			UB: "Quality measure",
			PN: "Production assistance",
			NR: "Retrofit",
			IB: "Installation / Start-up",
			II: "Installation integration",
			IC: "Internal repair",
			MB: "Trade fair service",
			HW: "Resource",
			TT: "Technician training",
			SK: "Customer training",
			RP: "Repair",
			RW: "Repair and maintenance",
			WA: "Maintenance"
		},
		reportTypes: {
			IA: "De-Installation / Relocation report",
			AC: "Application consulting report",
			IV: "Installation preparation report",
			BA: "Appraisal report",
			UV: "Safety inspection report",
			IG: "Installation of pre-owned machine report",
			UB: "Quality measure report",
			PN: "Production assistance report",
			NR: "Retrofit report",
			IB: "Installation / Start-up report",
			II: "Installation integration report",
			IC: "Internal repair report",
			MB: "Trade fair service report",
			HW: "Resource report",
			TT: "Technician training report",
			SK: "Customer training report",
			RP: "Repair reports",
			RW: "Repair and maintenance reports",
			WA: "Maintenance reports"
		},
		reportTypesPlural: {
			IA: "De-Installation / Relocation reports",
			AC: "Application consulting reports",
			IV: "Installation preparation reports",
			BA: "Appraisal reports",
			UV: "Safety inspection reports",
			IG: "Installation of pre-owned machine reports",
			UB: "Quality measure reports",
			PN: "Production assistance reports",
			NR: "Retrofit reports",
			IB: "Installation / Start-up reports",
			II: "Installation integration reports",
			IC: "Internal repair reports",
			MB: "Trade fair service reports",
			HW: "Resource reports",
			TT: "Technician training reports",
			SK: "Customer training reports",
			RP: "Repair reports",
			RW: "Repair and maintenance reports",
			WA: "Maintenance reports"
		},
		loadMore: "Load more",
		loadError: "Error loading service reports",
		noReportsFound: "No service reports found for the selected filter.",
		noReportsAvailable: "No service reports available."
	},
	missingAuthorization: "Missing permission",
	"headline.createCase": "Create New Service Case",
	"headline.caseDetails": "Case Details",
	"headline.contactData": "Contact Data",
	"field.reason.label": "Reason for Report",
	"field.application.label": "Application",
	"field.machine.label": "Machine & Machine Number",
	"field.applicationIssue.label": "Application Issue",
	"field.optics.label": "Optics",
	"field.softwareProblemClassification.label": "Issue Classification",
	"field.softwareInstallationProblem.label": "Installation Issue",
	"field.softwareLicenseIssue.label": "License Issue",
	"field.softwareType.label": "Software Type",
	"field.softwareModule.label": "Software Modules",
	"field.errorNumber.label": "Error Numbers",
	"field.errorNumber.explanation": "e.g., {{example1}}, {{example2}}, or {{example3}}",
	"field.errorNumber.addAnotherNumber": "+ add another error number",
	"field.errorNumber.errorMessage": "Invalid error number.",
	"field.message.label": "Message",
	"field.message.placeholder": "Please describe your concern/problem as concretely as possible and as detailed as necessary (without salutation). \nThank you very much.",
	"field.fileUpload.label": "File Upload",
	"field.fileUpload.info": "Permitted file formats: JPG, PNG, PDF, HTML, TruTops files etc. (max. 16 MB) and MP4 video files (max. 50 MB)",
	"field.salutation.label": "Salutation",
	"field.salutation.male": "Mr.",
	"field.salutation.female": "Ms.",
	"field.firstName.label": "First Name",
	"field.lastName.label": "Last Name",
	"field.email.label": "Email",
	"field.phone.label": "Phone Number",
	"button.submit": "Submit",
	"button.cancel": "Cancel",
	"button.back": "Back",
	"button.next": "Next",
	"button.close": "Close",
	"button.ok": "OK",
	"auth.error": "Authentication error. Please try again.",
	"select.placeholder": "Please select",
	"validation.requiredField": "This field is required",
	"validation.invalidEmail": "Please enter a valid email address",
	"validation.maxAllowedCharacters": "Maximum allowed characters: {{number}}",
	"validation.requiredFieldsExplanation": "Fields marked with an * are required.",
	"validation.invalidPhoneNumber": "Please enter a valid phone number",
	notificationType: {
		Maschinenstillstand: "Machine Downtime",
		"Störung ohne Stillstand": "Disruption without Downtime",
		"Programmierung / Software": "Programming / Software",
		"Klärung Ersatzteile": "Clarification of Spare Parts",
		Sonstiges: "Other",
		Wartungsanfrage: "Maintenance Request",
		"Bestellung Ersatzteile": "Ordering Spare Parts",
		Applikationsthemen: "Application Issues"
	},
	application: {
		welding: "Welding",
		plastic: "Plastic",
		cutting: "Cutting",
		hardening: "Hardening",
		marking: "Marking",
		other: "Other",
		fixedOpticsBEO: "Fixed Optics BEO",
		"PFO20/33": "PFO20/33",
		PFO3D: "PFO 3D",
		IPFO: "I-PFO",
		weldDepth: "Weld Depth",
		hardness: "Hardness",
		cracking: "Cracking",
		bubbleSplatter: "Bubble/Splatter",
		processData: "Process Data"
	},
	softwareProblemClassification: {
		standstill: "Standstill",
		fault: "Fault",
		slightImpairment: "Slight Impairment",
		generalInquiry: "General Inquiry"
	},
	softwareModule: {
		CAD: "CAD",
		Laser: "Laser",
		Punch: "Punch",
		Bend: "Bend",
		Tube: "Tube",
		HomeZone: "HomeZone",
		Design: "Design",
		Cut: "Cut",
		Storage: "Storage",
		Quickjob: "Quickjob"
	},
	"serviceCase.proactiveCaseClosure.title": "Feedback & Case closure request",
	"serviceCase.proactiveCaseClosure.instructions": "To request case closure and help us to improve our Predictive Service, we kindly ask for your feedback.",
	"serviceCase.proactiveCaseClosure.question.submit": "Send",
	"serviceCase.proactiveCaseClosure.dialogTitle": "Case closure requested. Thank you for your feedback.",
	"serviceCase.proactiveCaseClosure.dialog.buttonOk": "OK",
	"serviceCase.proactiveCaseClosure.question.anomaly": "Was the reported anomaly present on your machine?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideLinked": "Was a Technical Guide provided?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideHelpful": "Could you use the provided Technical Guide(s) to solve the problem on your own?",
	"serviceCase.proactiveCaseClosure.question.pauseRequest": "Would you like to pause notifications for this type of anomaly?",
	"serviceCase.proactiveCaseClosure.question.pauseRequestDuration": "For how long do you want to pause notifications for this type of anomaly?",
	"serviceCase.proactiveCaseClosure.question.comment": "Please explain why you would like to pause notifications for this type of anomaly:",
	"serviceCase.proactiveCaseClosure.question.commentPlaceholder": "Comment mandatory to request case closure and send feedback",
	"serviceCase.proactiveCaseClosure.answers.yes": "Yes",
	"serviceCase.proactiveCaseClosure.answers.no": "No",
	"serviceCase.proactiveCaseClosure.answers.sevenDays": "7 days",
	"serviceCase.proactiveCaseClosure.answers.fourteenDays": "14 days",
	"serviceCase.proactiveCaseClosure.answers.thirtyDays": "30 days",
	"serviceCase.proactiveCaseClosure.answers.ninetyDays": "90 days",
	"sisConnector.success.headline": "Case was successfully created",
	"sisConnector.success.orderNumberRequired": "Please add an order number for case billing and further services.",
	"sisConnector.success.technicalGuide.title": "A Technical Guide is available for these error number(s).",
	"sisConnector.success.technicalGuide.text": "Based on the entered error number(s), one or more Technical Guide(s) could be identified. In ca. 50% of cases you will now be able to solve your problem independently. This function is only available with a corresponding Service Contract.",
	"sisConnector.success.outsideOfServiceHours": "Please note that cases created outside our service hours will not be processed.",
	"sisConnector.success.serviceTimes.MonFri": "Our service times are: Monday to Friday",
	"sisConnector.success.serviceTimes.Sat": "and Saturday",
	"sisConnector.success.withTechnicalServiceHotline": "If you need immediate assistance, please call TRUMPF technical service {{hotline}} for support.",
	"sisConnector.success.withoutTechnicalServiceHotline": "If you need immediate assistance, please call TRUMPF technical service for support.",
	"sisConnector.success.caseId": "Case no.",
	"sisConnector.failed.headline": "Your service case could not be created",
	"sisConnector.failed.unknownError": "An unknown error occurred. Please try again later."
};
var enUS = {
	locale: locale,
	translations: translations
};

export { enUS as default, locale, translations };
//# sourceMappingURL=en-US-mBRzcvYw.js.map

//# sourceMappingURL=en-US-mBRzcvYw.js.map